export const API_URL = process.env.REACT_APP_API_URL;
export const summaryLogFields = [
    "Month",
    "Income-Expenses",
    "Issuance",
    "Balance",
    "Cost Demurrage",
    "# Incoming",
    "# Outgoing",
    "# Issues",
    "# Distinct Clients",
    "Avg Transaction Value",
];
export const dailyDigestFields = [
    "Day",
    "# Incoming",
    "Sum Incoming",
    "# Outgoing",
    "Sum Outgoing",
    "# Issuance",
    "Sum Issuance",
    "# Distinct Clients",
    "Avg Transaction Value",
];
